import type { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';

/**
 * Writing Training Session shell — no choice progress / answer sheet chrome.
 * Width matches Quiz reading/choice content rail (max-w-7xl).
 * Timer + word count live in WritingSessionPanel status row only.
 */
export function WritingSessionChrome({
  examLabel,
  sectionName,
  summaryLine = '1 个任务 · 随时可停',
  onExit,
  children,
}: {
  examLabel: string;
  sectionName: string;
  /** Task · word window · suggested time · stop-anytime */
  summaryLine?: string;
  onExit: () => void;
  children: ReactNode;
}) {
  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-slate-50">
      <header className="sticky top-0 z-30 flex-shrink-0 border-b border-slate-200 bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-4 sm:px-6 lg:px-8">
          <button
            type="button"
            onClick={onExit}
            className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-slate-200 bg-white text-slate-500 shadow-sm transition-colors hover:bg-slate-50 hover:text-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2"
            aria-label="结束本轮写作"
          >
            <ArrowLeft className="h-4 w-4" />
          </button>
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-slate-950 px-2.5 py-1 text-xs font-semibold text-white">
                写作练习
              </span>
              <span className="text-sm font-semibold text-slate-950">{examLabel}</span>
              <span className="text-sm text-slate-400">/</span>
              <span className="truncate text-sm font-medium text-slate-600">{sectionName}</span>
            </div>
            <p className="mt-1 text-xs text-slate-500">{summaryLine}</p>
          </div>
        </div>
      </header>
      <main className="min-h-0 flex-1 overflow-y-auto px-4 py-5 sm:px-6 sm:py-8 lg:px-8">
        <div className="mx-auto max-w-7xl">{children}</div>
      </main>
    </div>
  );
}
